export enum COLLAPSE_SIZES {
    LARGE,
    SMALL,
    BASE,
}
